import { GridRowSelectionModel } from '@mui/x-data-grid';
import { GridSortItem } from '@mui/x-data-grid/models/gridSortModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IObject } from '../interfaces/IObject';

interface DesignationState {
  selectedRow: GridRowSelectionModel;
  pageNumber: number;
  filters: IObject;
  sorting: GridSortItem[];
  editDetails: any;
  openCreateDesignation: boolean;
}

const initialState: DesignationState = {
  selectedRow: { type: 'include', ids: new Set() },
  pageNumber: 0,
  filters: { name: null },
  sorting: [],
  editDetails: null,
  openCreateDesignation: false,
};

const designationSlice = createSlice({
  name: 'designation',
  initialState,
  reducers: {
    setSelectedRow: (state, action: PayloadAction<GridRowSelectionModel>) => {
      state.selectedRow = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setFilters: (state, action: PayloadAction<IObject>) => {
      state.filters = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sorting = action.payload;
    },
    setEditDetails: (state, action: PayloadAction<any | null>) => {
      state.editDetails = action.payload;
    },
    setOpenCreateDesignation: (state, action: PayloadAction<boolean>) => {
      state.openCreateDesignation = action.payload;
    },
  },
});

export const {
  setSelectedRow,
  setPageNumber,
  setFilters,
  setSorting,
  setEditDetails,
  setOpenCreateDesignation,
} = designationSlice.actions;

export default designationSlice.reducer;
